import { render, staticRenderFns } from "./chat-message-plano.vue?vue&type=template&id=8b4ff218&scoped=true&"
import script from "./chat-message-plano.vue?vue&type=script&lang=js&"
export * from "./chat-message-plano.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-plano.vue?vue&type=style&index=0&id=8b4ff218&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ff218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b4ff218')) {
      api.createRecord('8b4ff218', component.options)
    } else {
      api.reload('8b4ff218', component.options)
    }
    module.hot.accept("./chat-message-plano.vue?vue&type=template&id=8b4ff218&scoped=true&", function () {
      api.rerender('8b4ff218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-message-plano/chat-message-plano.vue"
export default component.exports